import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { Component, inject, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp, getApp } from 'firebase/app';

@Component({
  selector: 'app-notify-floater',
  template: `
    <div *ngIf="message;" id="fcm-messenger" class="bg-warning rounded-3 shadow">
      <h5>{{ message.notification.title }}</h5>
      <p>{{ message.notification.body }}</p>
      <a class="underline">Ir a tarea</a>
    </div>
    <div *ngIf="!message;"></div>
  `,
  styles: []
})
export class NotifyFloaterComponent implements OnInit {

  message:any = null;
  interval:any = null;
  storageService = inject(StorageService);
  constructor() {
    // Initialize Firebase
    if (!getApp()) {
      initializeApp(environment.firebaseConfig);
    }
  }

  ngOnInit(): void {
    this.requestPermission();
    this.listen();
  }
  
  requestPermission() {
    const messaging = getMessaging();
    // requestToken(messaging).then((currentToken) => {});
    
    getToken(messaging, 
     { vapidKey: environment.firebaseConfig.vapidKey}).then(
       (currentToken) => {
         if (currentToken) {
           // console.log("Hurraaa!!! we got the token.....");
           // console.log(currentToken);
           this.storageService.saveItem(STORAGE_KEYS.FCM_TOKEN, currentToken);
         } else {
           console.log('No registration token available. Request permission to generate one.');
         }
     }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
  }
  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.message = payload;
      this.interval = setTimeout(() => {
        this.message = null;
      }, 4000);
    });
  }

}
